export const images = {
  heroBoardroom: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/190e787c-4a7c-4e76-9ebd-cf5a328472fb.jpg',
    alt: 'Senior business leaders in discussion around a boardroom table overlooking a city at dusk',
  },
  aboutConversation: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/a872bfdc-1e48-49ad-aff4-c0888bc6051a.jpg',
    alt: 'Two professionals in a quiet one-to-one conversation in a bright meeting room',
  },
  candidatePortrait: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/46fe9c81-184a-4306-b3de-0823d4c8c049.jpg',
    alt: 'An experienced professional standing by a window in a modern office',
  },
  boardroomEmpty: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/cb7fe8f0-66d4-4584-a1c9-e6737c513929.jpg',
    alt: 'An empty boardroom with a long table and city views in morning light',
  },
};
